<template>
<article>
    <div id="PageTitle">
        <div class="container">
            <h1 class="page-header">{{title}}</h1>
            <breadcrumb-trail :base='{ title: "Education @ Tūhura", url: "/learn"}' ></breadcrumb-trail>
        </div>
    </div>
    <div id="Pills">
        <div class="container">
            <ul class="nav nav-pills row">
        
            <router-link tag='li' exact-active-class="active" :to="{name: 'educationprogrammes'}"><a>Programmes</a></router-link>
        
            <li class=""><a href="/learn/sleepovers/">Sleepovers</a></li>
        
            <li class=""><a href="/learn/teachers/">Pre-visit Info</a></li>
        
            <router-link tag='li' exact-active-class="active" :to="{name: 'educationhome'}"><a>Online learning</a></router-link>
        
            <li class=""><a href="/learn/kia-rapua/">Kia Rapua</a></li>
        
            <li class=""><a href="/learn/showoffs-info/">Science Show Offs - Join the Fun!</a></li>
        
    </ul>

            <!-- <ul class="nav nav-pills row">
                <router-link tag='li' exact-active-class="active" :to="{name: 'resourcesearch',  query: { tag: 'View' }}"><a>View</a></router-link>
                <router-link tag='li' exact-active-class="active" :to="{name: 'resourcesearch',  query: { tag: 'Read' }}"><a>Read</a></router-link>
                <router-link tag='li' exact-active-class="active" :to="{name: 'resourcesearch',  query: { tag: 'Do' }}"><a>Do</a></router-link>
                <router-link tag='li' exact-active-class="active" :to="{name: 'resourcesearch',  query: { tag: 'Listen' }}"><a>Listen</a></router-link>
                <router-link tag='li' exact-active-class="active" :to="{name: 'topics'}"><a>Browse Topics</a></router-link>
            </ul> -->
        </div>
    </div> 
	<section id="Content">
		<div class="container">
            <div>
                <router-view @updateHead='updateHead'></router-view>
            </div>
		</div>
	</section>
</article>
</template>


<script>
import axios from 'axios';
import BreadcrumbTrail from '../../components/BreadcrumbTrail'

export default {
    data() {
        return {
            title: 'Education @ Tūhura'
        }
    },
    methods: {
        updateHead(title) {
            this.title = title;
            document.title = title + " | Tūhura Otago Museum";
        }
    },
    components: {
        'breadcrumb-trail': BreadcrumbTrail
    }
}
</script>